import React from "react";
import { Paragraph } from "@campgladiator/cgui-core.atoms.typography";
import { ChatBubble as BaseChatBubble } from "@campgladiator/cgui-core.molecules.chat-bubble";
import styles from "./ChatBubble.module.scss";

export type ChatBubbleProps = {
  authorFullName: string;
  formattedTime: string;
  note: string;
};

const ChatBubble = ({
  authorFullName,
  note,
  formattedTime,
}: ChatBubbleProps) => (
  <div className={styles.chatBubbleContainer}>
    <Paragraph size="small" className={styles.adminName}>
      {authorFullName}
    </Paragraph>
    <BaseChatBubble
      messageType="sent"
      text={note}
      timestamp={formattedTime}
      className={styles.chatBubble}
    />
  </div>
);

export default ChatBubble;
